angular.module('app')
.controller('LogoutCtrl', function ($scope, $rootScope, $userService, $storageService, $translate, $location) {
	
	$scope.init = function () {
		$translate.use("it");
		$('#menu-container').hide();
	}

	$scope.goToLogin = function () {
		$location.path('/login');
	}

})